<template>
  <div>
    <div id="menu-popup">
      <div id="main-wrapper">
        <div id="wshatIsHere-frame">
          <!-- menu and category header -->
        <ul class="tabs" v-if="headerVisible && !$root.$data.embedded && categoryFrames.length > 0 && isFromWhatIsHere ">
          <li
            v-for="frame in categoryFrames"
            :key="frame"
            :class="{active: currentComponent === frame}"
            @click="updateFrame(frame)" 
          >
            {{ $t("menuPopup." + frame) }}
          </li>
          <li class="tabs-close" @click.stop="goToCategories">
            <button >
              <img src="../../assets/icons/close1.png" alt="" />
            </button>
          </li>
        </ul>
        </div>
        <keep-alive v-if="!showRoutingMap">
          <component :is="currentTabComponent" @showHeader="showHeader" />
        </keep-alive>


        <Map3DMTK
          ref="map3d"
          v-if="!showRoutingMap"
          :lat="initialLat"
          :lng="initialLng"
          :zoom="initialZoom"
          :start="start"
          :end="end"
          :mode="currentRouteType"
          :triggerCalculation="triggerCalculation"
          :route="routeCoords"
        />
        <RoutingMTK
          v-if="!showRoutingMap"
          :start="start"
          :end="end"
          :mode="currentRouteType"
          :calculate="triggerCalculation"
          :selecting="selecting"
          @startSelected="start = $event"
          @endSelected="end = $event"
          @routeCalculated="onRouteCalculated"
          @routeReset="handleRouteReset"
        />
        <div class="routing-wrapper" v-if="!showRoutingMap">
          <button class="routing-button" @click="openDirectionFrame" :title="$t('buttons.routing')">
            <img
              src="@/assets/icons/delivery_24x24.png"
              alt="Routing Icon"
              style="height: 24px; width: 24px; margin-right: 8px"
            />
            {{ $t("buttons.routing") }}
          </button>
        </div>
      </div>
    </div>
    <div id="routing-map-wrapper">
      <MapRoutingMTK
        ref="routing"
        v-if="showRoutingMap"
        :initialLat="initialLat"
        :initialLng="initialLng"
        :initialZoom="initialZoom"
        :start="start"
        :end="end"
        :mode="currentRouteType"
        :triggerCalculation="triggerCalculation"
        @close="handleCloseRouting"
        @mapClicked="handleMapClick"
        @routeCalculated="onRouteCalculated"
      />
    </div>
  </div>
</template>

<script>
import MapRoutingMTK from "@/components/MapRoutingMTK.vue";
import SettingButtonsComponent from "@/components/button_controls/SettingButtons.vue";
import CategoriesFrame from "./CategoriesFrame.vue";
import StreetDirectoryFrame from "./StreetDirectoryFrame.vue";
import RoutingMTK from "@/components/RoutingMTK.vue";
import Vue from "vue";

export default {
  name: "MenuPopup",
  components: {
    CategoriesFrame,
    StreetDirectoryFrame,
    RoutingMTK,
    SettingButtonsComponent,
    MapRoutingMTK,
  },
  props: {
    initialLat: Number,
    initialLng: Number,
    initialZoom: Number,
    routingStart: Array,
    routingEnd: Array,
    routingMode: String,
  },
  data() {
    return {
      currentComponent: "pois",
      headerVisible: true,
      showRoutingMap: false,
      routeCoords: null,
      start: null,
      end: null,
      selecting: "start",
      currentRouteType: "foot",
      distanceText: null,
      durationText: null,
      triggerCalculation: 0,
    };
  },
   created() {
    const view = this.$route.params.view;
    if (view && this.categoryFrames.includes(view)) {
      this.currentComponent = view;
    } else if (this.$route.query.wh === "1") {
      this.currentComponent = "streets";
    }
  },
  computed: {
    currentTabComponent() {
      return this.currentComponent === "streets" && Vue.config.project.with_streets
        ? "StreetDirectoryFrame"
        : "CategoriesFrame";
    },
    categoryFrames() {
    return Vue.config.project.with_streets ? ["streets"] : [];
  },
    isFromWhatIsHere() {
    return this.$route.query.wh === "1"; 
  },
  },
  watch: {
    "$route.params.view"(view) {
      if (view && this.categoryFrames.includes(view)) {
        this.currentComponent = view;
        this.showRoutingMap = false;
      }
    },
    currentRouteType(newVal) {
      if (this.start && this.end) {
        console.log("Recalculating route for mode: MenuPopup", newVal);
        this.triggerCalculation++;
      } else {
        console.warn("No coordinates available for recalculation");
      }
    },
    initialLat: "logCoordonateComplete",
    initialLng: "logCoordonateComplete",
    initialZoom: "logCoordonateComplete",
  },
  mounted() {
    this._openRoutingHandler = (e) => this.openDirectionFrame(e.detail || {});
    window.addEventListener('openRoutingMapMTK', this._openRoutingHandler);

  },
  beforeDestroy() {
    window.removeEventListener('openRoutingMapMTK', this._openRoutingHandler);
  },

  methods: {

    goToCategories() {
      this.currentComponent = "pois";
      this.showRoutingMap = false;

      const q = { ...this.$route.query };
      delete q.wh;
      delete q.str_id;
      delete q.hnr;

      this.$router.push({
        name: this.$route.name,
        params: { ...this.$route.params, view: "pois" },
        query: q,
      }).catch(err => {
        if (err && err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    logCoordonateComplete() {
      if (this.initialLat && this.initialLng && this.initialZoom) {
        console.log("Coordonates set:", this.initialLat, this.initialLng, this.initialZoom);
      }
    },

    updateFrame(frame) {
      this.currentComponent = frame;
      this.showRoutingMap = false;
    },
    showHeader(visible) {
      this.headerVisible = visible;
    },
    openDirectionFrame(payload = null) {
        const global = this.$root.$data;
        this.$root.$emit("routingStatus", { isRoutingActive: true });

        const norm = (s) => {
          if (!s) return null;
          if (Array.isArray(s) && s.length >= 2) return { lat: Number(s[0]), lng: Number(s[1]) };
          if (typeof s === 'object') {
            if (typeof s.lat === 'number' && typeof s.lng === 'number') return { lat: s.lat, lng: s.lng };
            if (typeof s.lat === 'number' && typeof s.lon === 'number') return { lat: s.lat, lng: s.lon };
          }
          return null;
        };

        const startFromPayload = norm(payload?.start);
        const modeFromPayload  = payload?.mode;

        this.start = startFromPayload;     
        this.end   = null;
        this.selecting = 'end';            

        this.currentRouteType = modeFromPayload || global.routingMode || 'car';

        const pos = startFromPayload || global.globalRoutingPosition || null;
        if (pos?.lat && pos?.lng) {
          this.initialLat  = pos.lat;
          this.initialLng  = pos.lng;
          this.initialZoom = pos.zoom ?? 16;
        } else {
          this.initialLat  = 45.1;
          this.initialLng  = 28.8;
          this.initialZoom = 10;
        }

        this.routeCoords  = null;
        this.distanceText = null;
        this.durationText = null;

        this.showRoutingMap = true;
        this.$root.$emit("routingStatus", { isRoutingActive: true });
      },
    handleRoute({coords, summary}) {
      console.log("Route calculated:", coords, summary);
      this.routeCoords = coords;
      this.distanceText = (summary.distance / 1000).toFixed(2) + " km";

      const hours = Math.floor(summary.duration / 3600);
      const minutes = Math.round((summary.duration % 3600) / 60);
      this.durationText = `${hours > 0 ? hours + "h " : ""}${minutes}min`;

       this.$emit("routingStatus", {
        isRoutingActive: true,
        isRouting3DActive: false
      });
    },
    onRouteCalculated(data) {
      this.handleRoute(data);
    },

    handleRouteReset() {
      console.log("Route reset");
      this.routeCoords = null;
      this.distanceText = null;
      this.durationText = null;

    },
    handleCloseRouting() {
      this.showRoutingMap = false;
      this.start = null;
      this.end = null;
      this.routeCoords = null;
      this.distanceText = null;
      this.durationText = null;
      this.triggerCalculation++;
      this.$root.$emit("routingStatus", { isRoutingActive: false });

    },
    handleStartSelected(coords) {
      console.log("Start selected:", coords);
      this.start = coords;
      this.selecting = "end";
    },
    handleEndSelected(coords) {
      console.log("End selected::", coords);
      this.end = coords;
      this.triggerCalculation++;
    },

    handleMapClick({type, coords}) {
      if (this.$refs.routing?.handleMapClickFromMap) {
        this.$refs.routing.handleMapClickFromMap(type, coords);
      } else {
        console.warn("Invalid ref to mapRouting");
      }
    }
  }
};
</script>
<style scoped>

.tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;   
  padding: 6px 12px;

}

.tabs li {
  /* width: 9% !important; */
  list-style: none;
  display: flex;
  align-items: center;
  padding-left: 8px;
}


.tabs-close {
  width: 11% !important;
  /* margin-left: auto; */
}


.tabs-close button {
  width: 20% ;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

/* Icon-ul X */
.tabs-close img {
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.tabs-close img:hover {
  opacity: 1;
}


</style>
<style scoped lang="scss">
@import "@/assets/css/base";

#lhs_wrapper {
  position: relative;
  z-index: 10010; 
}

// @media (max-height: 700px) {
//   #lhs_wrapper {
//     max-height: 75vh;
//     overflow-y: auto;
//   }
// }


.tabs-close{
 position: relative;
}

#routing-map-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1; 
  pointer-events: none;
  display: block;
}

@include mobile {
  #routing-map-wrapper {
    z-index: 2;
    // display: block;
    pointer-events: none;
  }
}

.map-container {
  width: 100%;
  height: 100%;
  pointer-events: auto;
}

.maplibregl-map {
  z-index: 1 !important;
}
</style>
